<template>
    <div class="sidebarContainer">
      <!-- <label class="sidebarLabel"> -->
        <!-- <input type="checkbox" class="sidebarInput" /> -->
        <div class="boxes">
          <div class="options-arrow">
            <div  class="iconSidebar arrowIcon"
            @click="sidebarWidth()">
            <b-icon icon="chevron-left"></b-icon>

            </div>
            <p class="option addObj">Add Objects</p>
          </div>
          <div class="obstution-list">
          <div class="options" @click="drawObstructions(DRAW_OBSTRUCTION)">
            <div class="iconSidebar icons-size">
              <b-icon icon="pencil" ></b-icon>
            </div>
            <p class="option">Draw Obstruction</p>
          </div>
          <div class="options" @click="drawObstructions(MUMTY_OBSTRUCTION)">
            <img :src="allIcon.get('Rectangle3708')" alt="" class="iconSidebar img-border-rect" 
            />
            <p class="option">Mumty</p>
          </div>
          <div class="options" @click="drawObstructions(ACUNIT_OBSTRUCTION)">
            <img :src="allIcon.get('Rectangle3708')" alt="" class="iconSidebar img-border-rect"
            />
            <p class="option">AC Units</p>
          </div>
          <div class="options" @click="drawObstructions(CHIMNEY_OBSTRUCTION)">
            <img :src="allIcon.get('Ellipse251')" alt="" class="iconSidebar img-border-circle" 
            />
            <p class="option">Chimney</p>
          </div>
          <div class="options" @click="drawObstructions(WATERTANK_OBSTRUCTION)">
            <img :src="allIcon.get('Ellipse251')" alt="" class="iconSidebar img-border-circle" 
            />
            <p class="option">Water Tank</p>
          </div>
        </div>
        </div>
      <!-- </label> -->
    </div>
</template>

<script>
import utils from '@/pages/siteSurvey/utils';
import { ACUNIT_OBSTRUCTION, CHIMNEY_OBSTRUCTION, MUMTY_OBSTRUCTION, WATERTANK_OBSTRUCTION,DRAW_OBSTRUCTION } from './constants';
import {useStudioStore} from '../store/studioStore'
import { mapActions,mapState} from 'pinia';
import { useScreenSize } from '../../utils';

export default {
  data() {
    return {
      MUMTY_OBSTRUCTION: MUMTY_OBSTRUCTION,
      ACUNIT_OBSTRUCTION: ACUNIT_OBSTRUCTION,
      CHIMNEY_OBSTRUCTION: CHIMNEY_OBSTRUCTION,
      WATERTANK_OBSTRUCTION: WATERTANK_OBSTRUCTION,
      DRAW_OBSTRUCTION: DRAW_OBSTRUCTION,
      allIcon: utils.images,
      isObstructionHeightVisible:false,
      screenSize: useScreenSize(),
    };
  },
  created(){
    this.screenSize.setupListener();
  },
  beforeDestroy() {
    this.screenSize.removeListener();
  },
  mounted() {
    if(this.isObstructionSelected){
      document.getElementsByClassName("boxes")[0].classList.add("widthSidebar");
      document.getElementsByClassName("arrowIcon")[0].classList.add("rotateArrow");
      document.getElementsByClassName("addObj")[0].classList.add("hideText");
    }
},

computed: {
    ...mapState(useStudioStore, {
      isObstructionSelected: (state)=>state.isObstructionSelected,
    }),
    isMobileView(){
     return this.screenSize.isMobile ;
    },
  },

  methods: {
    ...mapActions(useStudioStore, {
      isObstructionHeightOpen: "OPEN_OBSTRUCTION_HEIGHT",
      setObstructionType:"SET_OBSTRUCTION_TYPE",
    }),
    sidebarWidth() {
      document.getElementsByClassName("boxes")[0].classList.toggle("widthSidebar");
      document.getElementsByClassName("arrowIcon")[0].classList.toggle("rotateArrow");
      document.getElementsByClassName("addObj")[0].classList.toggle("hideText");

    },
    drawObstructions(param) {
        this.isObstructionHeightOpen(true);
      this.setObstructionType(param);
      document.getElementsByClassName("boxes")[0].classList.add("widthSidebar");
      document.getElementsByClassName("arrowIcon")[0].classList.add("rotateArrow");
      document.getElementsByClassName("addObj")[0].classList.add("hideText");

    
    },
    openObstructionHeightPopup(){
      this.isObstructionHeightVisible=true;

    }
  }
};
</script>

<style  scoped>
@font-face {
  font-family: "SegoeUI";
  src: url(/fonts/SegoeUI.ttf);
}


.sidebarContainer {
    position: absolute;
    top: 182px;
    left: 12px;
    cursor: pointer;
  }

  .sidebarLabel {
    display: inline-block;
  }

  .sidebarInput {
    display: none;
  }

  .sidebarInput:checked ~ .boxes {
    width: 168px;
    height: 208px;
  }

  .boxes {
    width: 212px;
    height: 300px;
    border-radius: 8px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.3);
    background-color: #fff;
    overflow: hidden;
   
    padding: 12px 16px;
  }
  .obstution-list{
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .widthSidebar {
    width: 56px;
    height: 300px;
  }

  .arrowIcon {
    font-size: 24px;
    width: 28px;
  }

  .rotateArrow {
    transform: rotate(180deg);
  }

  .options {
    display: flex;
    align-items: center;
    gap: 16px;
  }
  .options-arrow{
    display: flex;
    align-items: center;
    gap: 8px;
    padding-bottom: 12px;
  }

  .option {
    white-space: nowrap;
    font-size: 16px;
    color: #222;
    font-family: "SegoeUI";
  }

  .addObj {
    font-size: 16px;
    font-weight: 600;
    color: #222;
  }

  .containerMD {
    display: inherit;
    position: fixed;
    bottom: 0px;
    width: 100%;
    padding: 16px;
    padding-bottom: 0px;
    border-top-right-radius: 8px;
    border-top-left-radius: 8px;
    background-color: #fff;
  }
  @media (max-width: 1100px) {
    
.sidebarContainer {
    top: 152px; /* add breathing room below back button on tablets/smaller desktops */
  }


}
@media (max-width: 500px) {
  .sidebarContainer {
    top: 168px; /* further spacing for compact mobile layouts */
  }
}
.icons-size{
  width: 30px;
  font-size: 24px;

}
.img-border-circle{
  border:1px solid #222;
  border-radius: 50px;
}
.img-border-rect{
  border:1px solid #222;
  border-radius: 4px;
}
.hideText{
  visibility: hidden;
}
</style>
